'use strict';
var $export = require('./$.export')
  , $pad    = require('./$.string-pad');

$export($export.P, 'String', {
  padRight: function padRight(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es7.string.pad-right.js
// module id = 567
// module chunks = 2